/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
 
 
/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
 
export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID,
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
        redirectUri: "/", // Will be overridden in index.js but default to current origin
        navigateToLoginRequestUrl: false, // Let the SPA handle routing after redirect
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },
    system: {  
        loggerOptions: {   
            loggerCallback: (level, message, containsPii) => {  
                if (containsPii) {     
                    return;    
                }
                if (level === 0 || level === 1) {
                    console.error('[MSAL]', message);
                }
            },
            logLevel: 1
        }  
    }
};